import React from "react";
import { useModal } from "hooks/Modal";

export default function ModalBody() {
    const { state } = useModal();

    return <div className="mt-2">{state.children}</div>;
}
